<div class="form-group">
    <div class="row">
        <div class="col-md-12">
            <label class="input-label" style="display: flex;justify-content: space-between">{{ 'reg.registrations_select' | translate }}
          </label>
            <div *ngIf="items.length > 0">
                <select [ngModel]="getSelectedItemId()"
                        name="selection"
                        (ngModelChange)="updateSelectedValue($event)"
                        class="form-control ng-pristine ng-invalid ng-invalid-required ng-touched"
                        required>
                        <option value="" default selected disabled>{{ 'Choose here' | translate }}</option>
                    <option *ngFor="let item of items" [value]="item.id" class="ng-binding">{{item.title}}{{item.name}}</option>
                </select>
            </div>
            <div *ngIf="items.length === 0">
                {{'No registration in the service is defined.' | translate}} {{'Press on' | translate}}
            </div>
        </div>
    </div>
</div>
